import * as constantes from '../../constantes';
import React, { Component } from 'react';
import { Button , Container , Form , Header , Grid , Icon , Message , Segment , Table } from 'semantic-ui-react'; 
import { Link , useParams } from "react-router-dom"; 
import './../../assets/eje.css';

import auth0Client from '../Auth/Auth'; 
const server = constantes.REST_API_PRIVATE;
const serverPu = constantes.REST_API_PUBLIC;

const style = {
    tabla: { 
        backgroundColor: '#FBF6F5', 
        marginLeft:'5%', 
    }, 
    div: { 
        marginTop: '20px', 
        marginBottom: '20px',
        alignContent: 'center',
        textAlign: 'center',  
    },
    divpie:{
        alignContent: 'center',
        textAlign: 'center',  
    },
    h1: {
        fontSize:'25px',
        marginTop: '1.5em',
        marginBottom: '1.5em',
    },
    h2: {
        margin: '4em 0em 2em',
    },
    h3: {
        marginTop: '2em',
        padding: '2em 0em',
    },
    last: {
        marginBottom: '300px',
    },
}

const WrappedResultadoCaso = props => {
   
    const params = useParams()

    return <ResultadoCaso id={params.id} />
}

class ResultadoCaso extends Component {
  
    constructor(props) {
      super(props);
      this.state = {
        isLoaded: false,
        errors: [],
        error: null,
        casoId: props.id,
        casoFinal : null
      };
    
      //this.descargarPlantilla = this.descargarPlantilla.bind(this);
      //

    }

    componentDidMount() {
        auth0Client.isExpired();
        this.cargarResultado(this.state.casoId);
    }

    cargarResultado( idCaso ) {
        let METHODNAME = 'cargarResultado - ';
        console.log(METHODNAME + 'INI'); 
       
        let url = server+`/resultado/${idCaso}/`;
        fetch( 
            url , {
            method: 'GET',
            headers:{
                'Accept':'application/json',
                'Content-Type':'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('AccessToken'),
            }
        })
        .then(res => res.json())
        .then(
            (result) => {
                console.log(METHODNAME + 'RESULTADO DEL CASO');
                console.log(METHODNAME + 'PRIMERA PREGUNTA = ' + result.casoResuelto.casoId  );

                this.setState({
                    isLoaded: true,
                    casoFinal : result.casoResuelto 
                });

            },
            
            (error) => {
                console.log(METHODNAME + 'error = ' + error );
                this.setState({
                    isLoaded: true,
                    error
                });
            }
        )

        console.log(METHODNAME + 'FIN');
    } 
    render() {
        //console.log( 'current = ' + this.state.currentState );

        const { error, isLoaded, casoFinal } = this.state;

        if (error) {
            return <div>Error: {error.message}</div>;
        } else if (!isLoaded) {
            return <div>Loading...</div>;
        } else {
            
            return(

                <Container>

                    <Form>
                    
                    <Header as='h3' content='Resultado de Evaluación de Caso' style={style.h1} textAlign='center' />
                    <Header as='h3' content='Ponencia Recomendada' style={style.h1} textAlign='center' />

                <Form.Field>

                    <Segment>
                        Datos Generales del Caso
                    </Segment>

                    <Segment>
                        <Table definition color='red'>
                            <Table.Body>
                                <Table.Row>
                                    <Table.Cell width={4}>Número de Expediente:</Table.Cell>
                                    <Table.Cell width={12}>{casoFinal.cnumExpediente}</Table.Cell> 
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell width={4}>Distrito Judicial:</Table.Cell>
                                    <Table.Cell width={12}>{casoFinal.ctxtProcedencia}</Table.Cell> 
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell width={4}>Fallo Primera instancia:</Table.Cell>
                                    <Table.Cell width={12}>{casoFinal.ctxtFallo1}</Table.Cell> 
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell width={4}>Fallo segunda instancia:</Table.Cell>
                                    <Table.Cell width={12}>{casoFinal.ctxtFallo2}</Table.Cell> 
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell width={4}>Proceso Constitucional:</Table.Cell>
                                    <Table.Cell width={12}>{casoFinal.tipoHabeasData ? casoFinal.tipoHabeasData.label : '--'}</Table.Cell> 
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell width={4}>Tipo de Resultado:</Table.Cell>
                                    <Table.Cell width={12}>{casoFinal.tipoResultado ? casoFinal.tipoResultado.nombre : '--'}</Table.Cell> 
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell width={4}>Tipo de Resolución Proyectada:</Table.Cell>
                                    <Table.Cell width={12}>{casoFinal.etapa && casoFinal.etapa.etapa ? casoFinal.etapa.etapa : '--' }</Table.Cell> 
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell width={4}>Fecha de fin de Analisis:</Table.Cell>
                                    <Table.Cell width={12}>{casoFinal.fechaFinAnalisis}</Table.Cell> 
                                </Table.Row>
                                { ( casoFinal.racPresentadoPor &&  casoFinal.racPresentadoPor.alternativaId )&&
                                <Table.Row>
                                    <Table.Cell width={4}>RAC se presentado por:</Table.Cell>
                                    <Table.Cell width={12}>{ casoFinal.racPresentadoPor.label }</Table.Cell> 
                                </Table.Row>
                                 }
                            </Table.Body>
                        </Table>

                        { casoFinal.involucrados && 
                        
                            <Table celled color='red'>
                                <Table.Header>
                                    <Table.Row key='head0002'>
                                        <Table.HeaderCell>Condición</Table.HeaderCell> 
                                        <Table.HeaderCell>Nombres</Table.HeaderCell>
                                        <Table.HeaderCell>Tipo Documento</Table.HeaderCell>
                                        <Table.HeaderCell>Número de Documento</Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body>
                                    { casoFinal.involucrados.map( involucrado => (
                                        <Table.Row key={involucrado.involucradoId}>
                                            <Table.Cell>{involucrado.tipoInvolucrado.nombre}</Table.Cell>
                                            <Table.Cell>{involucrado.nombreCompleto}</Table.Cell>
                                            <Table.Cell>{involucrado.tipoDocIdentidad.nombre}</Table.Cell>
                                            <Table.Cell>{involucrado.numeroDocIdentidad}</Table.Cell>
                                        </Table.Row>
                                    ))
                                    }                                
                                </Table.Body>
                            </Table> 
                        
                    }
                    
                    </Segment>

                    <div>                  
                        
                    <Segment>
                            Preguntas que generan resultado 
                    </Segment>

                    {casoFinal.motivosResultado &&
                        casoFinal.motivosResultado.map(item => (                  
                            <Segment>
                                <Grid columns={1}>
                                    <Grid.Column>

                                        <Table definition color='red'>
                                            <Table.Body>
                                                <Table.Row>
                                                    <Table.Cell width={4}>Pregunta resolutoria:</Table.Cell>
                                                    <Table.Cell width={12}>{item.pregunta.explicacionPregunta}</Table.Cell> 
                                                </Table.Row>
                                                {item.alternativa ? 
                                                <Table.Row>
                                                    <Table.Cell width={4}>Alternativa Seleccionada:</Table.Cell>
                                                    <Table.Cell width={12}>{item.alternativa.label}</Table.Cell> 
                                                </Table.Row>
                                                 : '' }
                                                <Table.Row>
                                                    <Table.Cell width={4}>Consecuencia:</Table.Cell>
                                                    <Table.Cell width={12}>{item.resolucionRac ? item.resolucionRac.consecuencia : '' }</Table.Cell> 
                                                </Table.Row>
                                                <Table.Row>
                                                    <Table.Cell width={4}>Motivo:</Table.Cell>
                                                    <Table.Cell width={12}>{item.resolucionRac ? item.resolucionRac.motivo : ''}</Table.Cell> 
                                                </Table.Row>
                                                <Table.Row style={ { display: 'none' } }>
                                                    <Table.Cell>
                                                        id Pregunta :  ({item.pregunta.idPregunta}) 
                                                        resultadoBoolean? : {item.resultadoBoolean ? 'true' : 'false '} 
                                                        Genera Rechazo? : {item.generaRechazo? 'true' : 'false '}
                                                        resultadoGenerado :  {item.resultadoGenerado}
                                                    </Table.Cell> 
                                                </Table.Row>
                                            </Table.Body>
                                        </Table>
                                        
                                    </Grid.Column>
                                    <Grid.Column >
                                        <Message
                                            color='blue' 
                                            header='Consideraciones sobre el Criterio del Tribunal:'
                                            content='Todo lo resaltado deberá ser verificado en el contenido del expediente por el asesor'
                                        />
                                    </Grid.Column>
                            <Grid.Column >
                                { item.resolucionRac && item.resolucionRac.plantillas &&
                                    <Table celled color='red'>
                                    <Table.Header>
                                        <Table.Row key='head0002'>
                                            <Table.HeaderCell>Resolución de ejemplo</Table.HeaderCell> 
                                            <Table.HeaderCell>Resolución en PDF</Table.HeaderCell>
                                            <Table.HeaderCell>Criterio del Tribunal</Table.HeaderCell> 
                                        </Table.Row>
                                    </Table.Header>
                                    <Table.Body>
                                        {item.resolucionRac.plantillas.map(it => ( 
                                            <Table.Row key={it.resolucionRacPlantillaId}>
                                                <Table.Cell>{it.codigo} <span  style={ {'display' : 'none' } } >{it.resolucionRacPlantillaId}</span></Table.Cell>
                                                <Table.Cell><a href={it.link} target='_blank' rel="noreferrer"> {it.nombre} </a></Table.Cell>
                                                <Table.Cell>
                                                    {it.tienePlantillaDocx === 1 ? 
                                                    <div>
                                                        <a href={`${serverPu}/dwnPonencia?id=${it.resolucionRacPlantillaId}_${casoFinal.casoId}`} target='_blank' rel="noreferrer"> 
                                                            {it.nombre} 
                                                        </a>  
                                                    </div>
                                                    : 
                                                        '--'
                                                    }
                                                </Table.Cell> 
                                            </Table.Row>
                                        ))
                                        }                                
                                    </Table.Body>
                                </Table> 
                                }
                             </Grid.Column>
                        </Grid>
                        </Segment>
                    ))}
  
                    <Grid>
                        <Grid.Row>
                            <Grid.Column textAlign='center' >
                                <Link to={`/listaAnalisis`} style={ {textAlign:'center'}}> 
                                    <Button primary  >
                                        <Icon name="reply" />Volver
                                    </Button>
                                </Link>
                            </Grid.Column> 
                        </Grid.Row>
                    </Grid>

                    </div>
                </Form.Field>
                
                </Form>
                </Container>
            );
    
        }
    }
  }
  
  export default WrappedResultadoCaso